export default __webpack_public_path__ + "22206b9975d26a041516ff5b0bacf5e4.svg";